import styled, { css } from 'styled-components';

export const NetworkStatusStyled = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.red[800]};
    color: ${theme.colors.white};
    bottom: 0;
    width: 100%;
    padding: ${theme.spacings[500]};
    position: absolute;
  `}
`;
